import { Gem, Sun, Users, Heart, Waves, PawPrint, Award, ShieldCheck, Headphones } from "lucide-react";

// Curated collection tiles on the homepage. `category` maps to the same
// category ids used by CategoryBar/CATEGORIES where one exists; tiles with
// no matching category (there's no dedicated "private pool" filter) link to
// the full villa list instead of fabricating a filter the backend can't serve.
export const COLLECTIONS = [
  { label: "Luxury Villas", Icon: Gem, category: "luxury", image: "https://images.unsplash.com/photo-1602343168117-bb8ffe3e2e9f?w=800&auto=format&fit=crop" },
  { label: "Weekend Getaways", Icon: Sun, category: "weekend", image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&auto=format&fit=crop" },
  { label: "Family Stays", Icon: Users, category: "family", image: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&auto=format&fit=crop" },
  { label: "Romantic Escapes", Icon: Heart, category: "couple", image: "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=800&auto=format&fit=crop" },
  { label: "Private Pool Villas", Icon: Waves, category: null, image: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=800&auto=format&fit=crop" },
  { label: "Pet Friendly", Icon: PawPrint, category: "pet", image: "https://images.unsplash.com/photo-1548199973-03cce0bbc87b?w=800&auto=format&fit=crop" },
];

export const WHY_NIRVAGOO = [
  { Icon: Award, title: "Handpicked stays", text: "Every villa is carefully selected for quality and experience." },
  { Icon: ShieldCheck, title: "Secure & simple", text: "Book with confidence, from search to stay." },
  { Icon: Heart, title: "Stays for what matters", text: "Family trips, celebrations, workations and more." },
  { Icon: Headphones, title: "Here for you", text: "Dedicated support, always." },
];

export const INSPIRATION = [
  { title: "The Ultimate Goa Villa Getaway", readTime: "5 min read", image: "https://images.unsplash.com/photo-1512343879784-a960bf40e7f2?w=900&auto=format&fit=crop" },
  { title: "Family Stays: Villas Made for Togetherness", readTime: "4 min read", image: "https://images.unsplash.com/photo-1529333166437-7750a6dd5a70?w=900&auto=format&fit=crop" },
  { title: "Hidden Gems in South India", readTime: "6 min read", image: "https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?w=900&auto=format&fit=crop" },
  { title: "Romantic Escapes: Villas Made for Two", readTime: "5 min read", image: "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=900&auto=format&fit=crop" },
  { title: "Pet-Friendly Villas Across India", readTime: "4 min read", image: "https://images.unsplash.com/photo-1548199973-03cce0bbc87b?w=900&auto=format&fit=crop" },
];

export const TESTIMONIALS = [
  {
    name: "Aanya Mehta",
    location: "Mumbai",
    quote: "Effortlessly curated. The villa exceeded everything the photos promised — quiet luxury at its finest.",
    img: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=300",
  },
  {
    name: "Rohan Kapoor",
    location: "Bangalore",
    quote: "From check-in to check-out, every detail felt considered. We've already booked our next stay.",
    img: "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=300",
  },
  {
    name: "Lara D'Souza",
    location: "Delhi",
    quote: "The booking experience is as luxurious as the homes. A category of its own.",
    img: "https://images.unsplash.com/photo-1554151228-14d9def656e4?w=300",
  },
];

export const FAQS = [
  { q: "How does Nirvagoo curate its villas?", a: "Every villa is hand-inspected by our local concierge teams. We only list homes that pass our 70-point standard for design, service, location and privacy." },
  { q: "What's included in the nightly rate?", a: "Daily housekeeping, Wi-Fi, utilities and concierge support. Chef services, experiences and transfers can be added at checkout." },
  { q: "Can I cancel my booking?", a: "Yes. Free cancellation up to 7 days before check-in. Partial refunds apply within 48 hours. See each villa's policy for details." },
  { q: "Is Nirvagoo available outside India?", a: "We currently operate across India with an expanding portfolio in Sri Lanka, Bali and the Maldives launching soon." },
];

export const HERO_IMAGE = "https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?w=2000&auto=format&fit=crop";
export const CTA_IMAGE = "https://images.unsplash.com/photo-1602343168117-bb8ffe3e2e9f?w=2000&auto=format&fit=crop";
